import React from 'react';
import PropTypes from 'prop-types';
import { getLocationsListSkeleton } from './LocationsListSkeleton.style';
import {
    HSA_SEARCH_FORM_DESTINATION_LOADING_RESULTS,
    withTrackComponentDisplayed
} from '../../utils/HtmlEvents';

const DEFAULT_NUMBER_OF_SKELETONS = 5;

const LocationsListSkeletonTitleEl = getLocationsListSkeleton({});
const LocationsListSkeletonSubTitleEl = getLocationsListSkeleton({});
const LocationsListSkeletonIconEl = getLocationsListSkeleton({
    borderRadius: 0,
    height: '25px',
    width: '25px',
});
const classNameLocationListSkeleton = 'prisma-responsive-space-horizontal prisma-dropdown-item '
    + ' odf-separator-dotted odf-space-inner-top-s odf-space-inner-bottom-s odf-space-inner-right-l odf-space-inner-left-l';


export const LocationsListSkeleton = withTrackComponentDisplayed(({
    numberOfSkeletons = DEFAULT_NUMBER_OF_SKELETONS,
}) => {
    const skeletonItems = [];
    for (let i = 0; i < numberOfSkeletons; i++) {
        skeletonItems.push((
            <div
                className={classNameLocationListSkeleton}
                data-testid='locations-list-skeleton-item'
                key={`locations-list-skeleton-item-${i}`}
            >
                <div className="odf-dropdown-col"><LocationsListSkeletonIconEl /></div>
                <div className="odf-dropdown-col lg odf-text-nowrap">
                    <LocationsListSkeletonTitleEl className="odf-space-outer-bottom-xs" />
                    <LocationsListSkeletonSubTitleEl />
                </div>
            </div>
        ));
    }
    return (
        <>{skeletonItems}</>
    );
}, HSA_SEARCH_FORM_DESTINATION_LOADING_RESULTS);

LocationsListSkeleton.propTypes = {
    numberOfSkeletons: PropTypes.number,
};

LocationsListSkeleton.defaultProps = {
    numberOfSkeletons: DEFAULT_NUMBER_OF_SKELETONS,
};

